//types
import { Team } from "../types/types";

export const teamsAC: Team = {
    "YOUNGBOYS": {
        id: "YOUNGBOYS",
        name: "Young Boys",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]
    },
    "JUVENTUS": {
        id: "JUVENTUS",
        name: "Juventus",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]
    },
    "ACMILAN": {
        id: "ACMILAN",
        name: "AC Milan",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]
    },    
    "BAYERN": {
        id: "BAYERN",
        name: "Bayern Munich",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]
    },
    "REALMADRID": {
        id: "REALMADRID",
        name: "Real Madrid",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },
    "SPORTING": {
        id: "SPORTING",
        name: "Sporting Lisboa",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },    
    "SPARTAPRAGA": {
        id: "SPARTAPRAGA",
        name: "Sparta Praga",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]   
    },
    "BOLOGNA": {
        id: "BOLOGNA",
        name: "Bologna",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },    
    "CELTIC": {
        id: "CELTIC",
        name: "Celtic",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },    
    "BRUJAS": {
        id: "BRUJAS",
        name: "Brujas",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]    
    },
    "MANCHESTERCITY": {
        id: "MANCHESTERCITY",
        name: "Manchester City",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]    
    },
    "PSG": {
        id: "PSG",
        name: "PSG",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]     
    },      
    "FEYENOORD": {
        id: "FEYENOORD",
        name: "Feyenoord",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]     
    },      
    "ESTRELLAROJA": {
        id: "ESTRELLAROJA",
        name: "Estrella Roja",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]   
    },    
    "MONACO": {
        id: "MONACO",
        name: "Monaco",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },
    "ATALANTA": {
        id: "ATALANTA",
        name: "Atalanta",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]     
    },     
    "ATLETICOMADRID": {
        id: "ATLETICOMADRID",
        name: "Atlético Madrid",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },
    "BREST": {
        id: "BREST",
        name: "Brest",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },
    "ASTONVILLA": {
        id: "ASTONVILLA",
        name: "Aston Villa",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            }
        ]
    },
    "PSV": {
        id: "PSV",
        name: "PSV",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]
    },
    "LIVERPOOL": {
        id: "LIVERPOOL",
        name: "Liverpool",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]
    },    
    "DINAMOZAGREB": {
        id: "DINAMOZAGREB",
        name: "Dinamo Zagreb",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]
    },
    "STTUTGART": {
        id: "STTUTGART",
        name: "Stuttgart",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },
    "LILLE": {
        id: "LILLE",
        name: "Lille",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },    
    "SALZBURG": {
        id: "SALZBURG",
        name: "Salzburgo",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]   
    },
    "SHAHKTAR": {
        id: "SHAHKTAR",
        name: "Shakhtar",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },    
    "SLOVANBRATISLAVA": {
        id: "SLOVANBRATISLAVA",
        name: "Slovan Bratislava",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },    
    "DORTMUND": {
        id: "DORTMUND",
        name: "Borussia Dortmund",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]    
    },
    "INTER": {
        id: "INTER",
        name: "Inter",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]    
    },
    "GIRONA": {
        id: "GIRONA",
        name: "Girona",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]     
    },      
    "BAYER-LEVERKUSEN": {
        id: "BAYER-LEVERKUSEN",
        name: "Bayer Leverkusen",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]     
    },      
    "BENFICA": {
        id: "BENFICA",
        name: "Benfica",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]   
    },    
    "BARCELONA": {
        id: "BARCELONA",
        name: "Barcelona",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },
    "ARSENAL": {
        id: "ARSENAL",
        name: "Arsenal",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]     
    },     
    "RBLEIPZIG": {
        id: "RBLEIPZIG",
        name: "Leipzig",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },
    "STURMGRAZ": {
        id: "STURMGRAZ",
        name: "Sturm Graz",
        seasons: [
            {
                name: 'unica',
                points: 0,
                playedMatches: 0,
                wonMatches: 0,
                drawnMatches: 0,
                lostMatches: 0, 
                goalsFor: 0,
                goalsAgainst: 0,
                goalsDifference: 0
            },
        ]  
    },
};

